import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { GlobalSearchRequest, GlobalSearchResponse } from "../proto/api_pb";

export const handleGlobalSearch = async (accessToken:string,userId:string,query:string):Promise<GlobalSearchResponse> => {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new GlobalSearchRequest();
    request.setUserId(userId);
    request.setQuery(query);
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };
    return await backOff(
        () =>
          new Promise((resolve, reject) => {
            ommuseClient.globalSearch(request, metadata, function (err, response) {
              if (err) {
                console.log("Error while getting response");
                console.log(err.message);
                reject(err);
              } else {
                resolve(response);
              }
            });
          }),
        {
          numOfAttempts: 3,
          jitter: "full",
        }
      );
  };